import React, { memo, useCallback } from 'react';
import { View, ScrollView } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Space,
  Text,
  Divider,
  IconBack,
  IconButton,
} from '@redlink/components/atoms';
import {
  PreviewGalleryPostCardTextBlock,
  PreviewLinksList,
} from '@redlink/components/muscles';
import { ImagesContainer } from './imagesContainer';
import { UserBadgeContainer } from './userBadgeContainer';
import { useNavigation, StackActions } from '@react-navigation/native';
import { useValues } from '@redlink/assets/values';

export const PreviewPostDetail = memo(
  ({
    data: {
      page: { fullname, avatar },
      post: {
        images,
        category: { title: categoryTitle },
        title,
        description,
        links,
      },
    },
    pageName,
  }) => {
    const { styles, colors } = useStyle();
    const { dispatch, canGoBack, goBack } = useNavigation();
    const { routes } = useValues();

    const navigateToPage = useCallback(() => {
      if (canGoBack()) {
        goBack();
      } else {
        dispatch(StackActions.replace(routes.preview.key, { pageName }));
      }
    }, [dispatch, routes, pageName, canGoBack, goBack]);

    return (
      <View style={styles.container}>
        <ScrollView showsVerticalScrollIndicator={false}>
          <ImagesContainer data={images} />
          <View style={styles.bodyContainer}>
            <PreviewGalleryPostCardTextBlock {...{ title, categoryTitle }} />
            <Space />
            <UserBadgeContainer
              avatarUrl={avatar?.thumbnailUrl}
              {...{ fullname }}
              onPress={navigateToPage}
            />
            <Space />
            <Divider color={colors.saparator} style={styles.divider} />
            <Space />
            <Text style={styles.descriptionText}>{description}</Text>
            <Space />
            <PreviewLinksList data={links} style={styles.linksContainer} />
          </View>
        </ScrollView>
        <IconButton style={styles.backIconContainer} onPress={navigateToPage}>
          <IconBack color={colors.gray23} />
        </IconButton>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, isRtl }) => ({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  bodyContainer: {
    padding: 24,
  },
  userContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  userAvatarImage: {
    width: 24,
    height: 24,
  },
  userTitleText: {
    color: colors.subtitle,
    fontSize: 14,
  },
  descriptionText: {
    color: colors.subtitle,
    fontSize: 14,
  },
  backIconContainer: {
    backgroundColor: colors.gray7,
    position: 'absolute',
    top: 16,
    ...(isRtl && {right: 16}),
    ...(!isRtl && {left: 16}),
  },
  linksContainer: {
    paddingHorizontal: 0,
    paddingBottom: 0,
  },
}));
